import { Country } from 'react-phone-number-input/input';

/**
 * ISO 3166-1 alpha-2 countries allowed to receive SMS.
 * Keep in sync with orient-action-api smsAllowedCountryCodes.js.
 */
export const SMS_ALLOWED_COUNTRIES: Country[] = [
  'AD',
  'AL',
  'AR',
  'AS',
  'AT',
  'AU',
  'BE',
  'BH',
  'BN',
  'BR',
  'BS',
  'CA',
  'CH',
  'CK',
  'CL',
  'CN',
  'CO',
  'CR',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FO',
  'FR',
  'GB',
  'GI',
  'GL',
  'GR',
  'HK',
  'HR',
  'HU',
  'IE',
  'IN',
  'IS',
  'IT',
  'JP',
  'KR',
  'LI',
  'LT',
  'LU',
  'LV',
  'MD',
  'MK',
  'MO',
  'MT',
  'MX',
  'NL',
  'NO',
  'NZ',
  'PF',
  'PL',
  'PR',
  'PT',
  'PW',
  'RE',
  'RO',
  'SE',
  'SK',
  'SM',
  'TH',
  'TR',
  'TW',
  'US',
  'UY',
  'VN',
];
